var _rect, _rect2, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _rect6, _polygon, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "websiteGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#5F7A61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F5F0E6"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 48,
    height: 36,
    fill: "url(#websiteGradient)",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 48,
    height: 8,
    fill: "#1C1917",
    rx: "4 4 0 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 20,
    r: 1.5,
    fill: "#ff5f56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 20,
    r: 1.5,
    fill: "#ffbd2e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 20,
    r: 1.5,
    fill: "#27ca3f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 40,
    height: 4,
    fill: "#FFFFFF",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 34,
    width: 32,
    height: 3,
    fill: "#FFFFFF",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 39,
    width: 36,
    height: 3,
    fill: "#FFFFFF",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 28,
    height: 3,
    fill: "#FFFFFF",
    rx: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "44,36 48,30 52,36 44,36",
    fill: "#E5DECF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 36,
    width: 4,
    height: 8,
    fill: "#E5DECF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 38,
    width: 2,
    height: 3,
    fill: "#1C1917"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.dbdfc0809c5b01a2f411d7711a734c23.svg";
export { ForwardRef as ReactComponent };